import { createTheme } from '@mui/material';

/**
 * Thème global de l'application.
 *
 * Volontairement minimal (= thème MUI par défaut) afin de NE RIEN changer au
 * rendu desktop existant : il sert uniquement de point central pour les
 * breakpoints (utilisés par le hook useIsMobile) et de socle pour de futurs
 * réglages communs. On n'ajoute volontairement PAS de <CssBaseline /> pour
 * éviter tout reset visuel qui modifierait l'apparence actuelle.
 *
 * NB : les écrans qui définissent leur propre <ThemeProvider> local
 * (DemandesScreen, DemandesScreenLegrand) continuent de surcharger ce thème
 * dans leur sous-arbre — comportement inchangé.
 */
const theme = createTheme();

export default theme;
